import { encryptCBC } from "@/utils/IMEI";

// 对公共接口加密处理
export function publicDataEncrypt(url) {
    const timestamp = new Date().getTime();
    const jsonStr = JSON.stringify({
        u_r_t: timestamp,
        u_r_p: url,
    });
    const iv = 'utc' + timestamp;
    const encryptStr = encryptCBC(jsonStr, 'lXynEnO7shPhWoXn', iv);
    return {
        timestamp,
        encryptStr,
    }
}
